import { popupService } from "./popup.service";
import { PopupModalService } from "./popup-modal.service";
import { SvcServices } from "./svc.service";
import { ContentService } from './content.service';
import { windowService } from "./window.service";
import { SiteCatalystService } from "./site-catalyst.service";
import { Inject, Injectable, Renderer2, RendererFactory2  } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { SiteCatalystPageData } from 'app/models';
import { OnInit } from '@angular/core';
import { Subscription } from "rxjs/internal/Subscription";
import DOMPurify from 'dompurify'; 

  /* DMAR - Digital Marketing using AdManager 360 (DFP)
   *
   * The following code directly accesses the DOM
   * TBD:
   *   - determine how to use local variable instead of global javascript
   *   - refactor to use Renderer2
   *   - refactor to load per Angular's lifecycle
   *
  */

@Injectable()
export class DmarService{
private _renderer: Renderer2;
  constructor(
    private popupService:popupService,
    public popupModalService:PopupModalService,
    public _svcService: SvcServices,
    public windowService: windowService,
    public _contentService: ContentService,
    private scService: SiteCatalystService,
    @Inject(DOCUMENT) private _document: Document,
    rendererFactory: RendererFactory2
  ) {
    this.firstAdLoaded = false;
    this.primaryDisclosureContentNotTriggered = true;
    this._renderer = rendererFactory.createRenderer(null, null);
    this.isAdBlockerEnabled();
  }
  firstAdLoaded : Boolean;
  primaryDisclosureContentNotTriggered : Boolean;
  isAdBlocking: boolean;
  scPageData: SiteCatalystPageData;
  globalData: any;
  pageData: any;
  private subscription: Subscription;
  private _primaryDisclosure = new Subject<any>();
  private _secondaryDisclosure = new Subject<any>();
  private _flexDisclosure = new Subject<any>();
  readonly primaryDisclosure: Observable<any> = this._primaryDisclosure.asObservable();
  readonly secondaryDisclosure: Observable<any> = this._secondaryDisclosure.asObservable();
  readonly flexDisclosure: Observable<any> = this._flexDisclosure.asObservable();
   // Note: similar function in Fusion Classic is named provision_gpt_tags()
  public request_ads(): void {
    
    if (this.windowService.nativeWindow.dataLayer) {
      if (this.windowService.nativeWindow.dataLayer.dmarLoadedList) {
        this.windowService.nativeWindow.dataLayer.dmarLoadedList = [];
      }
    }
    const windowData= this.windowService.nativeWindow;
    this.globalData = this._svcService.getGlobalData();
    const dataLayer = this.globalData.dataLayer;
    if(dataLayer.brandId == ''){
      dataLayer.brandId = "null";
    }
    const contentData = this._contentService;
    var domainURL = this.windowService.nativeWindow.location.origin;
    
    windowData["googletag"] = windowData["googletag"] || {
      cmd: []
      };

    let oBP = false;
    try {
      if (undefined !== this._svcService && null !== this._svcService) {
        if (undefined !== this._svcService.getSourceAdded() && null !== this._svcService.getSourceAdded()) {
          oBP = this._svcService.getSourceAdded();
        }
      }
    } catch (e) { }

    try {
      windowData["googletag"].cmd.push(function() {
        
        try {
          windowData["googletag"].destroySlots()
        } catch (a) {
          console.warn("Fusion UI: DFP config destroySlots issue.")
        }

        windowData["googletag"].pubads().addEventListener('slotOnload', function(event) {
          var id = event.slot.getSlotElementId();
          var parentContainer = document.getElementById(id);
          var iframeTitle = 'Advertisement - ' + id;

          if (parentContainer) {
              var children = parentContainer.getElementsByTagName('iframe');
              if (children && children.length === 1) {
                  var iframe = children[0];
                  iframe.setAttribute('title', iframeTitle);
              }
             }
          });

        try {
          windowData["googletag"].pubads().setForceSafeFrame(true).setSafeFrameConfig(
            { useUniqueDomain: true }
          );
          var pageConfig = {
            sandbox: true
          };
          windowData["googletag"].pubads().setSafeFrameConfig(pageConfig);
    
        } catch (a) {
          console.warn("Fusion UI: DFP config incorrect (3B).")
        }

        try {
          windowData["googletag"].pubads().setTargeting("pageName", dataLayer.pageName)
          .setTargeting("siteId",dataLayer.siteId)
          .setTargeting("brandId",dataLayer.brandId)
          .setTargeting("paperlessLetter",dataLayer.paperlessLetter)
          .setTargeting("paperlessStatement",dataLayer.paperlessStatement)
          .setTargeting("internalstatus",dataLayer.internalstatus)
          .setTargeting("externalstatus",dataLayer.externalstatus)
          .setTargeting("reasoncode",dataLayer.reasoncode)
          .setTargeting("autopay",dataLayer.autopay)
          .setTargeting("langId",dataLayer.langId)
          .setTargeting("emailPref",dataLayer.emailPref)
          .setTargeting("onlineBillPay", oBP ? "Y" : dataLayer.onlineBillPay)
          .setTargeting("zipcode",dataLayer.zipcode)
          .setTargeting("postalcode",dataLayer.postalcode)
          .setTargeting("state",dataLayer.state)
          .setTargeting("authOrJointUser",dataLayer.authOrJointUser)
          .setTargeting("cellPhoneConsent",dataLayer.cellPhoneConsent)
          .setTargeting("balconIndicator",dataLayer.balconIndicator)
          .setTargeting("balconPreQual",dataLayer.balconPreQual)
          .setTargeting("uniqueId",dataLayer.uniqueId)
          .setTargeting("sysprin",dataLayer.sysprin)
          .setTargeting("sysPrinAgent",dataLayer.sysPrinAgent)
          .setTargeting("copsIndicator",dataLayer.copsIndicator)
          .setTargeting("srsTYRewardPoints",dataLayer.srsTYRewardPoints)
          .setTargeting("brooksRewardPoints",dataLayer.brooksRewardPoints)
          .setTargeting("llBeanRewardsBalance",dataLayer.llBeanRewardsBalance)
          .setTargeting("macyVIPTier",dataLayer.macyVIPTier)
          .setTargeting("bbyTierLevel",dataLayer.bbyTierLevel)
          .setTargeting("strategyCodes",dataLayer.strategyCodes)
          .setTargeting("monthonBooks",dataLayer.monthonBooks)
          .setTargeting("partnerCSS",dataLayer.partnerCSS)
          .setTargeting("domainURL",domainURL)
          .setTargeting("dmarUniqueID",dataLayer.dmarUniqueID)
          .setTargeting("isKnownUser", contentData.isKnownUser().toString());
          if (domainURL.search("citiretailservices.citibankonline.com") != -1 || domainURL.search("retailservicesconsumer.citi.com") != -1) {
            windowData["googletag"].pubads().setTargeting("environment","prod");
          } else {
            if (domainURL.search("mobile.citibank.com") != -1) {
              var i = domainURL.indexOf('https://');
              var j = domainURL.indexOf('mobile.citibank.com');
              windowData["googletag"].pubads().setTargeting("environment",domainURL.substring(i+8,j-1));
            } else {
              windowData["googletag"].pubads().setTargeting("environment","dit06");  // dit07 Feb 2019 release
            }
          }

          if(dataLayer.siteId.indexOf("BESTBUY")!=-1)
          windowData["googletag"].pubads().setTargeting("bestBuyRewards",dataLayer.isEnrolledInRewards);
          else if(dataLayer.siteId.indexOf("SEARS")!=-1)
          windowData["googletag"].pubads().setTargeting("searsRewards",dataLayer.isEnrolledInRewards);

          let accountCode = "21708450700";
          let domObject = document.getElementsByClassName('fn-dmar');
          for (let i = 0; i < domObject.length; i++) {
            let slot = windowData["googletag"].defineSlot(
              "/"+accountCode+"/"+domObject[i].id, ['fluid'],
              ''+domObject[i].id);
            if (slot !== null) {
              slot.addService(windowData["googletag"].pubads());
            }
          }
          windowData["googletag"].pubads().enableSingleRequest();
          windowData["googletag"].enableServices();
          windowData["googletag"].pubads().refresh();
        } catch (a) {
          console.warn("Fusion UI: DFP config incorrect (4): " + a)
        }
      });
      //Commenting to prevent multiple Ad calls
     /* window["googletag"].cmd.push(function() {
        try {
          let domObject1 = document.getElementsByClassName('fn-dmar');
          for (let i = 0; i < domObject1.length; i++) {
            window["googletag"].display(''+domObject1[i].id);
          }
        } catch(err) {
          console.warn("Fusion UI: DFP config incorrect (5).");
        }
      });*/
    } catch(err) {
      console.warn("Fusion UI: DFP config incorrect (5).");
    }

  }

  // Handles PostMessages from DMAR ads
  public setup_listeners():void {

    // Note: similar function in Fusion Classic is in
    //       pseudoAppController beginning around line 500.

    this.windowService.nativeWindow.addEventListener("message", (event: any) => {

      /*this.scPageData = {

      }
      this.scService.setSCPageData("dmarAdClicked", null, JSON.parse(event.data));*/


      //this.scService.s

      // if not from DFP, ignore all messages
      // if on local browser, use http, othersize, use https
      //if(event.origin !== 'https://tpc.googlesyndication.com' && event.origin !== 'http://tpc.googlesyndication.com') {
       if (event.origin !== 'https://tpc.googlesyndication.com' && !event.origin.endsWith('.safeframe.googlesyndication.com')){
          console.warn("=== DMAR === Ignored message: event origin was invalid");
          return;
        }

      try {

        //var eventData = JSON.stringify(event.data);
		    var sanitizedJSON = DOMPurify.sanitize(event.data);
        var obj = JSON.parse(sanitizedJSON);

        /* TBD: === DMAR === console log messages are temporary
           and will be removed once DMAR handlers are implemented */

        // message: no ad unit defined, so ignore
        if (obj.adUnit == undefined || !obj.adUnit) {
          //console.log("=== DMAR === Ignored message: AdUnit undefined");
          return;
        }

        // event: ad is ready to be displayed
        if (obj.action == "displayAd") {
          //console.log("=== DMAR === message: I got a display ad event!");

          if (this.windowService.nativeWindow.dataLayer) {
            if (this.windowService.nativeWindow.dataLayer.dmarLoadedList) {
              this.windowService.nativeWindow.dataLayer.dmarLoadedList.push(obj.adUnit.substring(obj.adUnit.lastIndexOf("/") + 1));
            }
            else {
              this.windowService.nativeWindow.dataLayer.dmarLoadedList = [obj.adUnit.substring(obj.adUnit.lastIndexOf("/") + 1)];
            }
          }

          // Explain how this works.

          if (!this.firstAdLoaded) {
            this.firstAdLoaded = true;
            setTimeout(() => {
              this.scService.setSCPageData('dmarAdsLoaded', null);
            }, 2000);
          }

		// Getting disclosure text

          if (obj.adUnit.toString().toLowerCase().includes('primary')) {
            if ('true' == obj.hasDisclosureContents.toLowerCase() && this.primaryDisclosureContentNotTriggered) {
              this.sendPrimayDisclosureMessage(obj.disclosureContents);
              this.primaryDisclosureContentNotTriggered = false;
            }
          }
          if (obj.adUnit.toString().toLowerCase().includes('secondary')) {
            if ('true' == obj.hasDisclosureContents.toLowerCase()) {
              this.sendSecondaryDisclosureMessage(obj.disclosureContents);
            }
          }
          if (obj.adUnit.toString().toLowerCase().includes('flex')) {
            if ('true' == obj.hasDisclosureContents.toLowerCase()) {
              this.sendFlexDisclosureMessage(obj.disclosureContents);
            }
          }

          return;
        }
        // event: user expanded or collapsed Terms and Conditions
        if ('expandexclusion' == obj.action || 'collapseexclusion' == obj.action) {
          if (this.windowService.nativeWindow.dataLayer) {
            this.windowService.nativeWindow.dataLayer.dmarLastTouch = obj.adUnit.substring(obj.adUnit.lastIndexOf("/") + 1);
          }
          this.scService.setSCPageData('dmarAdInteraction', null);
          return;
        }

        // event: user requested email to be sent
       if ("sendemail" == obj.action) {
        if (this.windowService.nativeWindow.dataLayer) {
          this.windowService.nativeWindow.dataLayer.dmarLastTouch = obj.adUnit.substring(obj.adUnit.lastIndexOf("/") + 1);
        }
        this.scService.setSCPageData('dmarAdInteraction', null);
          return;
        }

        // event: user requested display of Terms and Conditions Overlay
        if ("displayTCOverlay" == obj.action) {
          if (this.windowService.nativeWindow.dataLayer) {
            this.windowService.nativeWindow.dataLayer.dmarLastTouch = obj.adUnit.substring(obj.adUnit.lastIndexOf("/") + 1);
          }
          this.scService.setSCPageData('dmarAdInteraction', null);
          this.popupService.openTncMarketingPopup.emit(obj);
          return;
        }

        if (obj.action != undefined && obj.action) {
          if ("signonDisclosureLinkClick" == obj.action) {
           if (this.windowService.nativeWindow.dataLayer) {
             this.windowService.nativeWindow.dataLayer.dmarLastTouch = obj.adUnit.substring(obj.adUnit.lastIndexOf("/") + 1);
            }
           this.scService.setSCPageData('dmarAdInteraction', null);
           let disclosureTncObj = { };
           disclosureTncObj["disclosureTncAction"] = obj.action;
           disclosureTncObj["disclosureTncHeadline"] = obj.disclosureTncHeadline;
           disclosureTncObj["disclosureTncCopy1"] = obj.disclosureTncCopy1;
           disclosureTncObj["disclosureTncCopy2"] = obj.disclosureTncCopy2;
           disclosureTncObj["disclosureTncCopy3"] = obj.disclosureTncCopy3;
           disclosureTncObj["disclosureTncCopy4"] = obj.disclosureTncCopy4;
           disclosureTncObj["disclosureTncCopy5"] = obj.disclosureTncCopy5;
           disclosureTncObj["disclosureCloseDialogADA"] = obj.disclosureCloseDialogADA;
           this.popupModalService.openPopupContent.emit({
              popupContentComponent:"popup-site-disclosure-tnc",
              popupContentParams: disclosureTncObj
            });
           return;
          }
        }

        // event: user clicked a link
        if (obj.link != undefined && obj.link) {
          if (this.windowService.nativeWindow.dataLayer) {
            this.windowService.nativeWindow.dataLayer.dmarLastTouch = obj.adUnit.substring(obj.adUnit.lastIndexOf("/") + 1);
          }
          this.scService.setSCPageData('dmarAdInteraction', null);
          if((obj.link.indexOf(this.windowService.nativeWindow.location.origin)>=0) || (obj.link.indexOf("citiretailservices.citibankonline.com")>=0)) {
           
            window.open(obj.link, "_new");
          }
          else if (/^http/.test(obj.link)) {
            // External URL - need to go via speedbump
            let speedBumpObj = { };
            let domain = ((obj.link.startsWith("https")) ? obj.link.slice(8) : obj.link.slice(7));
            domain = ((domain.startsWith("www.")) ? domain.slice(4) : domain.slice(0));
            domain = domain.toLowerCase().replace(/(?:^|\s)[a-z]/g, function (m) {
              return m.toUpperCase();
            });
            speedBumpObj["fullHref"] = obj.link;
            speedBumpObj["host"] = domain;
            speedBumpObj["target"] = "_blank";      // to open the link in a new tab.
            this.popupModalService.openPopupContent.emit({
              popupContentComponent:"popup-site-redirect",
              popupContentParams: speedBumpObj
            });
          }
          else {
            // Internal URL
            // Note: always redirect back to Fusion BAU, it will figure out the right URL
            //   this is because DFP must have a unified set of links to use for both BAU and NGA
            // Local testing: this will not resolve locally, it will always go to a 404 page
            this.windowService.nativeWindow.location.href = this.globalData.redirectURL+obj.link;
          }
          return;
        }

        console.warn("=== DMAR === Ignored message: had ad unit, but not handled");

      } catch(err) {

        // lots of exceptions are expected, as DFP by default sends many messages we don't care about
        return;
      }

    },false)
  }

// To check if the adblocker is enabled
   public isAdBlockerEnabled(){
	    var detectAdBlocker = this._renderer.createElement('div');
	    this._renderer.setAttribute(detectAdBlocker, 'id', 'dmar_adblock_id');
      this._renderer.setAttribute(detectAdBlocker, 'class', 'ad ads ad-placement doubleclick carbon-ads adsbox pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links ad-text adSense adBlock adContent adBanner');
	    detectAdBlocker.innerHTML = '&nbsp;';
        this._renderer.appendChild(this._document.body, detectAdBlocker);
	    if (detectAdBlocker.offsetHeight === 0) {
	      console.log('***Ad Blocker is ON***');
	      this.isAdBlocking = true;
	    } else {
	      console.log('***Ad Blocker is OFF***');
	      this.isAdBlocking = false;
	    }
	    if(this._document.body.getElementsByClassName("adsbox").length>0){
	    	//this._document.body.querySelector(".adsbox").remove();
	    	this._renderer.removeChild(this._document.body, detectAdBlocker);
	    }
     
    }

    //method to check if Primary banner content need to different from FLEX SEO content

    public primaryContentDiffFromFlexSeo() {
      this.getPageData();
      if (this.pageData
        && this.pageData.config$$cfg_cw_app_client_settings
        && this.pageData.config$$cfg_cw_app_client_settings.unique_content_on_primary_banner
        && this.pageData.config$$cfg_cw_app_client_settings.unique_content_on_primary_banner.includes(this._svcService.getSiteId())){
        console.log('unique_content_on_primary_banner for ' + this._svcService.getSiteId() + ' is true');
        return true;
      } else {
        if(this.pageData===undefined || this.pageData===null){
          console.log('this.pageData is undefined or null');
        }
        console.log('unique_content_on_primary_banner for ' + this._svcService.getSiteId() + ' is false');
        return false;
      }
    }

    getPageData(){
      this.subscription = this._contentService.module_content.subscribe((data) => {
        if (data !== null && data !== undefined) {
          if((data.content && data.content.CARDS) || (data.value) ){
          this.pageData = (data.value) ? data.value.content.CARDS : data.content.CARDS;
          }
        }
      });
      this.subscription.unsubscribe();
    }
  	// Updating the Disclosure Observables

  	public sendPrimayDisclosureMessage(message: any) {
      this._primaryDisclosure.next({ message });
    }
    public sendSecondaryDisclosureMessage(message: any) {
      this._secondaryDisclosure.next({ message });
    }
    public sendFlexDisclosureMessage(message: any) {
      this._flexDisclosure.next({ message });
    }
}
